module.exports = __webpack_public_path__ + "static/media/status-checkmark.451c0aad.svg";